import type {Layout} from "./types"

export const seatSpacingPolicy = (variant: number) =>
    `${Math.max(0, variant - 1)} ${variant === 2 ? "Platz" : "Plätze"} frei`

export const layoutDisplayName = (layout: Layout) => {
    const variant = Number(layout.key.match(/VARIANT_(\d+)/)?.[1])
    return Number.isFinite(variant) && variant >= 2
        ? `${seatSpacingPolicy(variant)} – ${layout.capacity} Prüfungsplätze`
        : layout.name
}
